<ng-container *ngIf="cs.vm$ | async as vm">
  <div [content]="banner" editable-area></div>

  <dgx-components-grid-row>
    <dgx-components-grid-column [md]="12">
      <us-registration-appliance-details-stepped-form
        (activeStep)="cs.triggerAdditionalContentVisible($event)"
        (submitted)="cs.onFormSubmit($event)"
        [clientBrandCode]="vm.clientBrandCode"
      />
    </dgx-components-grid-column>
  </dgx-components-grid-row>

  <dgx-components-grid-section [themeFlush]="true" class="mt-5 mb-12">
    <dgx-components-grid-container>
      <dgx-components-grid-row *ngIf="vm.additionalContentVisible" class="mt-5">
        <dgx-components-grid-column
          [md]="12"
          class="appliance-details__additional-content"
        >
          <div class="appliance-details__canadian-customer mb-5">
            <a [href]="canadaUrl">
              <img alt="Canada Flag" src="assets/images/flag-canada.png" />
              Registering in Canada? Visit here</a
            >
          </div>
          <us-registration-appliance-stepped-benefits-panel
            [benefitsPanel]="vm.cmsData.applianceDetailsSteppedBenefitsPanel"
          />
        </dgx-components-grid-column>
      </dgx-components-grid-row>
    </dgx-components-grid-container>
  </dgx-components-grid-section>

  <div [content]="main" editable-area></div
></ng-container>
